import { UserRoles } from '../modules/user/user.constants';

export const config = {
  'getAllTeams': [UserRoles.SUPERUSER],
  'getAllTransactions': [UserRoles.SUPERUSER],
};


// WEBPACK FOOTER //
// ./src/acl/index.js